<template>
  <generic-modal
    :value="value"
    :is-disabled="loading"
    :is-loading="loading"
    title="Create New Buy Guide"
    persistent
    hide-louis
    @modal-confirm="onCreateConfirm"
    @modal-cancel="onCreateCancel"
  >
    <div class="d-flex text-caption mb-2">
      <v-icon class="mr-1" small>info</v-icon>
      <span>This modal is for <b>NEW</b> Buy Guides only. New guides will default to English.</span>
    </div>

    <div class="text-caption mb-2">
      To create a <b>TRANSLATED</b> Buy Guide, navigate to an existing guide's EDIT view and select
      <i>'Add Language'</i> under the Languages section.
    </div>
    <v-form ref="form">
      <div class="d-flex">
        <toggle-input v-model="formData.is_default" label="Is Default" class="ml-auto mb-4" />
      </div>
      <select-list v-model="formData.type" :rules="rules.type" :items="types" label="Type" hide-details class="mb-6" />
      <select-list
        v-if="!formData.is_default"
        v-model="formData.entity_id"
        :items="entities"
        label="Entity"
        :rules="rules.entity_id"
        hide-details
        clearable
        class="mb-4"
      />
      <select-list
        v-if="formData.is_default"
        v-model="formData.entity_type_id"
        :items="entityTypes"
        label="Entity Type"
        hide-details
        clearable
        class="mb-4"
      />
    </v-form>
  </generic-modal>
</template>

<script>
import { buyGuides } from '@/services/offers'

import GenericModal from '@/components/modals/generic-modal'
import SelectList from '@/components/forms/select-list'
import ToggleInput from '@/components/forms/toggle-input'

const blankBuyGuide = () => ({
  type: null,
  language_id: null,
  entity_id: null,
  entity_type_id: null,
  is_default: true,
  buy_guide: {},
})

export default {
  components: { ToggleInput, SelectList, GenericModal },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    entities: {
      type: Array,
      required: true,
    },
    entityTypes: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      rules: {
        type: [v => !!v || 'Type is required'],
        language_id: [v => !!v || 'Language is required'],
        entity_id: [v => !!v || 'Entity is required'],
      },
      formData: blankBuyGuide(),
    }
  },
  watch: {
    'formData.is_default'() {
      this.formData.entity_id = null
      this.formData.entity_type_id = null
    },
  },
  methods: {
    reset() {
      this.formData = blankBuyGuide()
    },
    async onCreateConfirm() {
      if (!this.$refs.form.validate()) return
      this.loading = true

      try {
        const language_id = this.languages.find(({ key }) => key === 'English').value
        const { id } = await buyGuides.create({ ...this.formData, language_id })
        this.$notify({ type: 'success', text: 'Successfully created Buy Guide' })
        this.$router.push({ name: 'content.buy-guides.edit', params: { id } })
      } catch (error) {
        this.$notify({ type: 'error', text: 'Unable to create Buy Guide', data: { error }, duration: -1 })
      }
      this.loading = false
    },
    onCreateCancel() {
      this.reset()
      this.$emit('toggle')
    },
  },
}
</script>
